/**
 * Styled Components - Created by cazarez on 20/02/18.
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'
import { GRAY_DARK, BLUE, BLUE_SKY, BLUE_LIGHT, WHITE, WHITE_TRANSPARENT } from '../../theme/colors'
import Icon from 'antd/lib/icon'

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  transition: all .25s;
`

export const LoginLabel = styled.div`
  height: 25px;
  width: 100%;
  color: ${GRAY_DARK};
  font-size: 18px;
  font-weight: 600;
  line-height: 25px;
  text-align: center;
  margin-bottom: 40px;
`

export const FormContainer = styled.div`
  transition: all .25s;
`

export const StyledInput = styled(Input)`
  border-radius: 0px;
  margin-bottom: 20px;
`

export const RememberMeRow = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  height: 19px;
  color: ${GRAY_DARK};
  font-size: 14px;
  line-height: 19px;
  text-align: right;
  margin-bottom: 20px;
`

export const JoinNowLabel = styled.span`
  font-weight: bold;
  margin-left: 8px;
  font-family: Avenir;
  color: ${BLUE};
  &:hover {
    cursor: pointer;
  }
`
export const StyledLoginButton = styled(Button)`
  background-color: ${BLUE_SKY};
  border-color: ${BLUE};
  color: ${WHITE};
  border-radius: 0px;
  height: 50px;
  margin-bottom: 10px;
  width: 100%;
  &:hover {
    background: ${BLUE_LIGHT} !important;
    color: ${WHITE};
  }
`

export const NotAMemberLabel = styled.div`
  height: 22px;
  width: 100%;
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 17px;
  line-height: 22px;
  text-align: center;
  margin-bottom: 50px;
`

export const ForgotPasswordLabel = styled.div`
  &:hover {
    cursor: pointer;
  }
`

export const LoginFailedView = styled.div`
  animation: fade-in-bottom 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  text-align: center;
  @keyframes fade-in-bottom {
    0% {
      transform: translateY(-20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const LoginFailed = styled.div`
  margin: 0 10px;
  font-size: 15px;
  p {
    margin-bottom: 2px;
  }
`

export const OkButton = styled(Button)`
  background: ${BLUE};
  color: ${WHITE};
  margin-top: 10px;
  align-items: center;
`

export const InputIcon = styled(Icon)`
  margin-left: -3px;
`

export const LoadingContainer = styled.div`
  width: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 10000;
  height: 100vh;
  background: ${WHITE_TRANSPARENT};
  display: flex;
  justify-content: center;
  align-items: center;
`
export const OrLabel = styled.div`
  height: 27px;
  margin: 0 24px;
  color: ${GRAY_DARK};
  font-size: 14px;
  line-height: 25px;
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
`

export const LoginDeprecatedView = styled.div`
  animation: fade-in-bottom 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  text-align: center;
  @keyframes fade-in-bottom {
    0% {
      transform: translateY(-20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const DeprecatedInfo = styled.div`
  margin: 0 10px;
  font-size: 15px;
  p {
    margin-bottom: 28px;
  }
`

export const SendEmailButton = styled(Button)`
  background: ${BLUE};
  color: ${WHITE};
  align-items: center;
`

export const ContactDiv = styled.div`
  margin-top: 25px;
  font-size: 12px;
`

export const MessageSentDiv = styled.div``

export const MessageSentIcon = styled(Icon)`
  font-size: 46px;
  margin-top: 28px;
  margin-bottom: 22px;
`

export const MessageSentText = styled.div`
  max-width: 212px;
  margin-top: 10px;
  margin-bottom: 12px;
  font-weight: bold;
  font-family: Avenir;
  font-size: 18px;
`

export const StyledInputDeprecated = styled(Input)`
  margin: 0 auto;
  border-radius: 0px;
  margin-bottom: 20px;
  width: 70%;
  display: flex;
  margin-top: -10px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/Login/styledComponents.tsx